@if(loading$ | async) {
<app-loading class="h-100 w-100 loading-container" [text]="'Loading'"></app-loading>
} @else {
<app-script-card-tile
  [cardList]="scriptCards"
  [loading]="loading"
  (onActionFireEvents)="
    onActionFireEvents($event.event, $event.actionType, $event.$event)
  "
></app-script-card-tile>
}
